import React from 'react'

function AlertMessage({ message, onDismiss, isDarkMode = false }) {
	if (!message) return null

	return (
		<div
			className={`alert-box ${
				message.type === 'success' ? 'alert-success' : 'alert-error'
			} ${isDarkMode ? 'dark' : ''}`}
		>
			<div className="flex-1">
				<div className="text-xs">{message.message}</div>
				{message.actionUrl && (
					<a
						href={message.actionUrl}
						target="_blank"
						rel="noopener noreferrer"
						className="text-sm underline inline-block"
					>
						{message.action === 'install'
							? 'Install Extension'
							: 'Update Extension'}
					</a>
				)}
			</div>
			<button
				onClick={onDismiss}
				className="text-sm ml-3 opacity-70 hover:opacity-100 w-6 h-6 flex items-center justify-center"
			>
				×
			</button>
		</div>
	)
}

export default AlertMessage
